import React, { useState } from 'react';
import WorldviewPicker from './onboarding/WorldviewPicker';
import PathScreen from './onboarding/PathScreen';
import PreceptCheck from './onboarding/PreceptCheck';
import { logEvent } from '../lib/analytics';

export default function Onboarding() {
  const [worldview, setWorldview] = useState(null);
  const [stage, setStage] = useState('worldview');

  const handleWorldview = (w) => {
    setWorldview(w);
    setStage('path');
  };

  const handleDone = () => {
    setStage('precepts');
  };

  return (
    <div className="onboarding">
      {stage === 'worldview' && <WorldviewPicker onSelect={handleWorldview} />}
      {stage === 'path' && worldview && <PathScreen worldview={worldview} onDone={handleDone} />}
      {stage === 'precepts' && <PreceptCheck />}
    </div>
  );
}
